import React from 'react';
import { MemoryEditContext } from 'contexts/MemoryEditContext';
import { useParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { useMemoryByID } from 'hooks/memory/useMemoryByID';
import type { MemoryEditContextValue } from 'contexts/MemoryEditContext';

// Define the types
interface MemoryEditContextProps {
  children: React.ReactNode;
}

// Create a Provider component
const MemoryEditContextProvider = ({ children }: MemoryEditContextProps) => {
  const { id: memoryID } = useParams();
  const { error } = useMemoryByID(memoryID);
  if (!memoryID) {
    return (
      <Grid
        height='100vh'
        container
        justifyContent='center'
        alignItems='center'
      >
        <Typography color={(theme) => theme.palette.grey[800]}>
          Memory ID Not Found
        </Typography>
      </Grid>
    );
  }

  if (error instanceof Error && error.message === 'Forbidden') {
    return (
      <Box sx={{ textAlign: 'center', paddingTop: '10px' }}>
        Error accessing this memory
      </Box>
    );
  }

  // Provide the context value to the children
  const contextValue: MemoryEditContextValue = {
    memoryID,
  };

  return (
    <MemoryEditContext.Provider value={contextValue}>
      {children}
    </MemoryEditContext.Provider>
  );
};

export default MemoryEditContextProvider;
